//import Input from "components/shared/inputs/input";
import { useEffect } from "react";
import { useGetUserInfoQuery } from "store/api";
//import { useAuth } from "utils/hooks/useAuth";
import Button from "components/shared/button";
import useTranslation from "utils/hooks/useTranslation";
//import CustomUpload from "components/shared/customUpload";
import useCustomForm from "utils/hooks/useCustomForm";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import Loader from "components/shared/loader";
import { usePopup } from "providers/PopupProvider";
import { ProfilePopup } from "components/popups/ProfilePopup";
import { useSalesNetwork } from "utils/hooks/useSalesNetworks";
import ProfilePicture from "components/ProfilePicture";
import NeedHelp from "components/NeedHelp";
import { useAppSelector } from "store/hooks";
import { writeDataLayer } from "utils/helpers";

export const ProfilePage: React.FC = () => {
  const { t } = useTranslation();

  const { data: userInfo, isLoading } = useGetUserInfoQuery(undefined);
  const { isThermor } = useSalesNetwork();
  const { openPopup, closeLastPopup } = usePopup();
  const authState = useAppSelector((state) => state.auth);

  const phoneRegExp = /^[\+]?[0-9]{9,15}$/im;
  const schema = yup
    .object({
      email: yup.string().required("Email is required"),
      firstName: yup.string().required("First name is required"),
      lastName: yup.string().required("Last name is required"),
      contact: yup.string().required("Contact is required"),
      address_postale: yup.string(),
      code_postal: yup.string(),
      ville: yup.string(),
      societe: yup.string().required("Societe is required"),
      telephone: yup.string().matches(phoneRegExp, "Phone number is not valid"),
    })
    .required();

  const {
    reset,
    // formState: { isDirty, errors },
  } = useCustomForm<UserInfo>({
    defaultValues: userInfo,
    resolver: yupResolver(schema) as any,
  });

  useEffect(() => {
    if (userInfo) {
      reset(userInfo);
    }
  }, [userInfo]);

  useEffect(() => {
    writeDataLayer('mon compte', authState);
  }, []);

  const getNoteByEnv = () => {
    let trad = 'PERSONNAL_DATA_NOTE'
    if (isThermor) trad = 'PERSONNAL_DATA_NOTE_thermor'

    return t(trad).replace(/([a-z0-9._-]+@[a-z0-9.-]+\.[a-z]{2,4})/gi, '<a href="mailto:$1">$1</a>')
  }

  return (

    <group data-align="center" data-direction="column">
      <group data-max-length="1440">
        <form
          // onSubmit={handleSubmit(handleUpdate)} 
          data-type="group"
        >
          {isLoading ? (
            <Loader />
          ) : (
            <>
              <group data-space="20" data-length="autofit" data-gap="20" data-adaptive="desktop">
                <group
                  data-border=""
                  data-radius="extra-special"
                  data-space="25"
                  data-gap="5"
                  direction="column"
                  data-align="start"
                  data-length="autofit"
                  data-background="main-background"
                >
                  <group data-gap="5">
                    <group>
                      <text data-text-size="22" data-color="grey-color-dark">
                        {t("ACCOUNT_INFO")}
                      </text>
                    </group>
                    <separator data-horizontal=""></separator>
                    <group data-gap="5">
                      <group data-gap="30">
                        <text>{userInfo?.lastname} {userInfo?.firstname}</text>
                      </group>
                      <separator data-horizontal=""></separator>
                      <group data-gap="30">
                        <text>{userInfo?.phone || t('ACCOUNT_PHONE')}</text>
                      </group>
                      <separator data-horizontal=""></separator>
                      <group data-gap="30">
                        <text>{userInfo?.fax || t('ACCOUNT_FAX')}</text>
                      </group>
                      <separator data-horizontal=""></separator>
                      <group data-gap="30">
                        <text>{userInfo?.email || t('ACCOUNT_EMAIL')}</text>
                      </group>
                      <separator data-horizontal=""></separator>
                      <group data-gap="30">
                        <text>{userInfo?.www || t('ACCOUNT_WWW')}</text>
                      </group>
                      <separator data-horizontal=""></separator>
                      <group data-gap="30">
                        <Button
                          //primary
                          large
                          text={t("UPDATE")}
                          icon="edit"
                          data-background="secondary"
                          data-color="white"
                          onClick={() => {
                            //handleSubmit(handleUpdate, onError)();
                            openPopup(
                              <ProfilePopup
                                closePopup={closeLastPopup}
                              ></ProfilePopup>)
                          }}
                        />
                      </group>
                    </group>
                  </group>
                </group>
              </group>

              <group data-space="20" data-length="autofit" data-gap="20" data-adaptive="desktop">
                <group
                  data-border=""
                  data-radius="extra-special"
                  data-space="25"
                  data-gap="20"
                  //direction="column"
                  data-align="start"
                  //data-length="autofit"
                  data-background="main-background"
                >
                  <group data-gap="5">
                    <group>
                      <text data-text-size="22" data-color="grey-color-dark">
                        {t("ACCOUNT_MY_COMPANY")}
                      </text>
                    </group>
                    <separator data-horizontal=""></separator>
                    <group data-gap="30" data-wrap="no">
                      <text>{t("ACCOUNT_COMPANY_NAME")}</text>
                      <text data-wrap="wrap">{userInfo?.companyName}</text>
                    </group>
                    <separator data-horizontal=""></separator>
                    <group data-gap="5">
                      <group data-gap="30">
                        <text>{t("ACCOUNT_NUMBER")}</text><text>{userInfo?.siret}</text>
                      </group>
                    </group>
                    <separator data-horizontal=""></separator>
                    <group data-gap="5">
                      <group data-gap="30">
                        <text>{userInfo?.address1 || t('ACCOUNT_ADDRESS1')}</text>
                      </group>
                    </group>
                    <separator data-horizontal=""></separator>
                    <group data-gap="5">
                      <group data-gap="30">
                        <text>{userInfo?.address2 || t('ACCOUNT_ADDRESS2')}</text>
                      </group>
                    </group>
                    <separator data-horizontal=""></separator>
                    <group data-gap="5">
                      <group data-gap="30">
                        <text>{userInfo?.city || t('ACCOUNT_CITY')}</text>
                      </group>
                    </group>
                    <separator data-horizontal=""></separator>
                    <group data-gap="5">
                      <group data-gap="30">
                        <text>{userInfo?.postalcode || t('ACCOUNT_POSTALCODE')}</text>
                      </group>
                    </group>
                    <separator data-horizontal=""></separator>
                    <group data-gap="5">
                      <group data-gap="30">
                        <text>{
                          userInfo?.policyNumber || t('ACCOUNT_POLICY_NUMBER')
                        }</text>
                      </group>
                    </group>
                    <separator data-horizontal=""></separator>
                    <group data-gap="30">
                      <Button
                        large
                        text={t("UPDATE")}
                        icon="edit"
                        data-background="secondary"
                        data-color="white"
                        onClick={() => openPopup(<ProfilePopup closePopup={closeLastPopup} />)}
                      />
                    </group>
                  </group>
                </group>
              </group>

              <group data-space-horizontal="20" data-length="autofit" data-gap="20" data-adaptive="mobile">
                <group
                  //data-border=""
                  //data-radius="extra-special"
                  data-space-horizontal="25"
                  data-gap="5"
                  direction="column"
                  data-align="start"
                  data-length="autofit"
                  data-background="main-background"
                >
                  <ProfilePicture />
                  <group data-gap="5">
                    <group data-gap="5">
                      <separator data-horizontal=""></separator>
                      <group data-gap="5">
                        <text data-wrap="nowrap"><text>{t("ACCOUNT_LASTNAME")}</text><text>:</text></text><text data-weight="700" data-wrap="wrap">{userInfo?.lastname}</text>
                      </group>
                      <separator data-horizontal=""></separator>
                      <group data-gap="5">
                        <text data-wrap="nowrap"><text>{t("ACCOUNT_FIRSTNAME")}</text><text>:</text></text><text data-weight="700" data-wrap="wrap">{userInfo?.firstname}</text>
                      </group>
                      <separator data-horizontal=""></separator>
                      <group data-gap="5">
                        <text data-wrap="nowrap"><text>{t("ACCOUNT_PHONE")}</text><text>:</text></text><text data-weight="700" data-wrap="wrap">{userInfo?.phone}</text>
                      </group>
                      <separator data-horizontal=""></separator>
                      <group data-gap="5">
                        <text data-wrap="nowrap"><text>{t("ACCOUNT_FAX")}</text><text>:</text></text><text data-weight="700" data-wrap="wrap">{userInfo?.fax || t("non renseigné")}</text>
                      </group>
                      <separator data-horizontal=""></separator>
                      <group data-gap="5">
                        <text data-wrap="nowrap"><text>{t("ACCOUNT_EMAIL")}</text><text>:</text></text><text data-weight="700" data-wrap="wrap">{userInfo?.email}</text>
                      </group>
                      <separator data-horizontal=""></separator>
                      <group data-gap="5">
                        <text data-wrap="nowrap"><text>{t("ACCOUNT_WWW")}</text><text>:</text></text><text data-weight="700" data-wrap="wrap">{userInfo?.www}</text>
                      </group>
                      <separator data-horizontal=""></separator>
                      <group data-gap="5">
                        <text data-wrap="nowrap"><text>{t("ACCOUNT_NUMBER")}</text><text>:</text></text><text data-weight="700" data-wrap="wrap">{userInfo?.siret}</text>
                      </group>
                      <separator data-horizontal=""></separator>
                      <group data-gap="5">
                        <text data-wrap="nowrap"><text>{t("ACCOUNT_COMPANY_NAME")}</text><text>:</text></text><text data-weight="700" data-wrap="wrap">{userInfo?.companyName}</text>
                      </group>
                      <separator data-horizontal=""></separator>
                      <group data-gap="5">
                        <text data-wrap="nowrap"><text>{t("ACCOUNT_ADDRESS1")}</text><text>:</text></text><text data-weight="700" data-wrap="wrap">{userInfo?.address1}</text>
                      </group>
                      <separator data-horizontal=""></separator>
                      <group data-gap="5">
                        <text data-wrap="nowrap"><text>{t("ACCOUNT_ADDRESS2")}</text><text>:</text></text><text data-weight="700" data-wrap="wrap">{userInfo?.address2}</text>
                      </group>
                      <separator data-horizontal=""></separator>
                      <group data-gap="5">
                        <text data-wrap="nowrap"><text>{t("ACCOUNT_CITY")}</text><text>:</text></text><text data-weight="700" data-wrap="wrap">{userInfo?.city}</text>
                      </group>
                      <separator data-horizontal=""></separator>
                      <group data-gap="5">
                        <text data-wrap="nowrap"><text>{t("ACCOUNT_POLICY_NUMBER")}</text><text>:</text></text><text data-weight="700" data-wrap="wrap">{""}</text>
                      </group>

                      <separator data-horizontal=""></separator>
                      <group data-gap="30" data-space-vertical="20">
                        <Button
                          //primary
                          large
                          text={t("UPDATE")}
                          icon="edit"
                          data-background="secondary"
                          data-color="white"
                          onClick={() => {
                            //handleSubmit(handleUpdate, onError)();
                            openPopup(
                              <ProfilePopup
                                closePopup={closeLastPopup}
                              ></ProfilePopup>)
                          }}
                        />
                      </group>
                    </group>
                  </group>
                </group>
              </group>

              <group data-space="20" data-length="fit" data-gap="20">
                <group data-gap="5">
                  <text data-weight="700">{t("PERSONNAL_DATA")}</text>
                </group>
                <text data-wrap="preline" data-link dangerouslySetInnerHTML={{ __html: getNoteByEnv() }}></text>
              </group>

            </>
          )}


        </form>
      </group>

      <NeedHelp />
    </group>

  );
};
